import Image from "next/image";
import Link from "next/link";

import logo from "../../public/images/image3.png";
import ecollat from "../../public/images/Group.png";
import icef from "../../public/images/icef.jpeg";

import FooterData from "../../data/footer.json";
import SingleFooter from "./FooterProps/SingleFooter";
import CopyRight from "./CopyRight";
import { useEffect, useState } from "react";
import { getData, postData } from "@/Action/api";
import { Countrydream } from "@/Action/apirouts";
import { API_URL } from "@/Constant";

const FooterThree = () => {
  const [countriesdata, setCountriesdata] = useState([]);
  const [courseData, setCourseData] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const result = await getData(`${API_URL}${Countrydream}`);

        const navData = await postData(`/get/courses?size=12&page=${1}`);
        setCourseData(navData?.data?.Courses);
        setCountriesdata(result?.data?.countries);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  return (
    <>
      <footer className="rbt-footer footer-style-1">
        <div className="footer-top">
          <div className="container">
            {FooterData &&
              FooterData.footerOne.map((footer, index) => (
                <div className="row row--15 mt_dec--30" key={index}>
                  <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30">
                    <div className="footer-widget">
                      <div className="logo">
                        <Link href="/">
                          <Image
                            src={logo}
                            width={152}
                            height={50}
                            priority={true}
                            alt="Edu-cause"
                          />
                        </Link>
                      </div>

                      <p className="description mt--20">{footer.description}</p>

                      <div className="contact-btn mt--30">
                        <Link
                          className="rbt-btn hover-icon-reverse btn-border-gradient radius-round"
                          href="/contact-us"
                        >
                          <div className="icon-reverse-wrapper">
                            <span className="btn-text">Contact Us</span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                            <span className="btn-icon">
                              <i className="feather-arrow-right"></i>
                            </span>
                          </div>
                        </Link>
                      </div>

                      <div className="rbt-icef-badge mt--30">
                        <a
                          href="https://www.icef.com/agency/6591"
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label="ICEF Accredited Agency #6591"
                          style={{
                            display: "inline-block",
                            background: "#fff",
                            padding: "8px",
                            borderRadius: "10px",
                            lineHeight: 0,
                          }}
                        >
                          <Image
                            src={icef}
                            width={100}
                            height={117}
                            alt="ICEF Accredited Trusted Agency #6591"
                          />
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-1 col-md-6 col-sm-6 col-12 mt--30">
                    {" "}
                    <Link href={"/"}>
                      <h5 className="ft-title">Home</h5>
                    </Link>
                    <Link href={"/events"}>
                      <h5 className="ft-title">Events</h5>
                    </Link>
                    <div className="footer-widget"></div>
                  </div>
                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Study Destinations"
                    footerType={countriesdata?.slice(0, 6) ?? []}
                    BaseUrl={null}
                    RedirectValue={"slug"}
                  />

                  <SingleFooter
                    classOne="col-lg-2 col-md-6 col-sm-6 col-12 mt--30"
                    title="Study Courses"
                    footerType={courseData?.slice(0, 6) ?? []}
                    BaseUrl={"study-courses"}
                    RedirectValue={"id"}
                    visibleValue={"masterCourse"}
                    FirstSection={"Study"}
                  />

                  <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt--30">
                    <div className="footer-widget">
                      <h5 className="ft-title">Get Contact</h5>
                      <ul className="ft-link">
                        <li>
                          <span>Phone:</span> <div>+91-9338000045</div>
                        </li>
                        <li>
                          <span>E-mail:</span>{" "}
                          <div href="mailto:hr@example.com">
                            info@immigurus.com
                          </div>
                        </li>
                        <li>
                          <span>Head Location:</span> Immigration Gurus Private
                          Limited, SCO-340, Mugal Canal, Karnal, Haryana, 132001
                        </li>
                      </ul>
                      <ul className="social-icon social-default icon-naked justify-content-start mt--20">
                        {footer.socialLink.map((value, innerIndex) => (
                          <li key={innerIndex}>
                            <Link href={value.link}>
                              <i className={value.icon}></i>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </footer>
      <CopyRight />
    </>
  );
};

export default FooterThree;
